import React, { useState, useEffect, useRef, useContext } from "react";
import "../../site/scss/_sport_v2.scss";
import { GlobalContext } from './header/GlobalContext';
import LastFiveStatsModal from "./modals/LastFiveStatsModal";
import { DateTime } from "luxon";

const AthleteCard = (props) => {
  const [countdown, setCountdown] = useState("");
  const [statKey, setStatKey] = useState(props.athlete.stat_key);
  const [statValue, setStatValue] = useState(props.athlete.stat);
  const [athleteEasy, setAthleteEasy] = useState(props.athlete.easy);
  const [athleteHard, setAthleteHard] = useState(props.athlete.hard);
  const [showStatModal, setShowStatModal] = useState(false);
  const intervalRef = useRef(null);
  const loggedIn = document.body.classList.contains('logged-in');
  const [promo, setPromo] = useState(props.athlete.promo);
  const { isH2H, isAdmin } = useContext(GlobalContext);
  const { athlete, onClick, selected, index } = props;
  const locationTxt = athlete.location == 'away' ? '@' : 'vs. ';
  let startTime = athlete.start_time;
  let moreSelected = false;
  let lessSelected = false;
  let moreLess = (!athleteEasy && !athleteHard && !athlete.promo);
  let startTimeObj = new Date(athlete.start_time_obj);
  // Ensure ISO 8601 parsing for older devices
  if (typeof athlete.start_time_obj === "string" && athlete.start_time_obj.includes("T")) {
    startTimeObj = new Date(athlete.start_time_obj);
  } else if (typeof athlete.start_time_obj === "string") {
    // Fallback: convert to ISO 8601 if not already
    startTimeObj = new Date(athlete.start_time_obj.replace(" ", "T"));
  }
  let currentTime = new Date();
  let startCountdown = startTimeObj.getTime() - currentTime.getTime() < 3600000 && startTimeObj.getTime() - currentTime.getTime() > 0;

  const getUserTimeZone = () => {
    return DateTime.local().zoneName;
  };

  const formatStartTime = (startTimeObj) => {
    const userTimeZone = getUserTimeZone();
    const startDateTime = DateTime.fromJSDate(startTimeObj).setZone(userTimeZone);
    const today = DateTime.local().setZone(userTimeZone).startOf('day');

    const format = startDateTime < today || startDateTime >= today.plus({ days: 1 })
      ? "ccc. h:mm a"
      : "h:mm a";

    return `${startDateTime.toFormat(format)} ${startDateTime.offsetNameShort}`;
  };

  if (startCountdown) {
    let countdown = startTimeObj.getTime() - currentTime.getTime();
    let minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((countdown % (1000 * 60)) / 1000);
    startTime = "Starting in " + minutes + "m " + seconds + "s";
  } else {
    startTime = formatStartTime(startTimeObj);
  }

  let athleteMatchSearch = selected.findIndex((x) => x.athlete_id == athlete.athlete_id && x.stat_key == athlete.stat_key);
  let athleteMatch = athleteMatchSearch > -1;
  if (athleteMatch) {
    let matching = selected[athleteMatchSearch];
    let moreMatch = matching.selected == "more";
    moreSelected = athleteMatch && moreMatch;
    lessSelected = athleteMatch && !moreMatch;
  }

  useEffect(() => {
    updateCountdown();
    intervalRef.current = setInterval(updateCountdown, 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  const updateCountdown = () => {
    // Always use ISO 8601 for parsing
    let startTimeObj;
    if (typeof props.athlete.start_time_obj === "string" && props.athlete.start_time_obj.includes("T")) {
      startTimeObj = new Date(props.athlete.start_time_obj);
    } else if (typeof props.athlete.start_time_obj === "string") {
      startTimeObj = new Date(props.athlete.start_time_obj.replace(" ", "T"));
    } else {
      startTimeObj = new Date(props.athlete.start_time_obj);
    }
    const currentTime = new Date();
    const countdown = startTimeObj.getTime() - currentTime.getTime();

    // Check if the event starts within 2 hours (7200000 milliseconds) or if promo is true
    if (countdown < 0 || (!props.athlete.promo && countdown > 7200000)) {
      setCountdown(""); // Clear countdown or set to a default message
      clearInterval(intervalRef.current);
      return;
    }

    const hours = Math.floor((countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countdown % (1000 * 60)) / 1000);
    let countdownString = '';
    if (hours > 0) {
        countdownString += `${hours}h `;
    }
    countdownString += `${minutes}m ${seconds}s`;
    setCountdown(countdownString);
  };

  const handleInfoClick = (type) => {
    if (type === "easy") {
      $("#easy-modal").modal("show");
    } else if (type === "hard") {
      $("#hard-modal").modal("show");
    } else {
      $("#promo-modal").modal("show");
    }
  };

  const handleStatSwap = () => {
    let altStats = props.athlete.alt_stats;
    let keys = Object.keys(altStats);
    let index = keys.indexOf(statKey);
    let nextIndex = index + 1;
    if (nextIndex >= keys.length) {
      nextIndex = 0;
    }

    // if key contains goblin, set easy/hard
    if (keys[nextIndex].includes("goblin")) {
        setAthleteEasy(true);
        setAthleteHard(false);
        setPromo('easy');
    } else if (keys[nextIndex].includes("demon")) {
        setAthleteEasy(false);
        setAthleteHard(true);
        setPromo('hard');
    } else {
        setAthleteEasy(false);
        setAthleteHard(false);
        setPromo('');
    }

    setStatKey(keys[nextIndex]);
    setStatValue(altStats[keys[nextIndex]]);
  };

  const closeModal = () => {
    setShowStatModal(false);
  };

  return (
    <div className={"athlete-card flex-fill m-2" + (moreSelected || lessSelected ? " b-selected" : "")}>
      <div className="outer-mf">
        <div className="more-info">

        { athlete.league !== 'cs2' && athlete.league !== 'lol' && athlete.league !== 'val' && athlete.league !== 'dota2' && (
          <>
            <label htmlFor={`graph-button-${athlete.athlete_id}`} className="sr-only">View Stats</label>
            <button id={`graph-button-${athlete.athlete_id}`} className="graph" onClick={() => setShowStatModal(true)} aria-label="View Stats">
              <i className="fa-solid fa-chart-simple" aria-hidden="true"></i>
            </button>

            {(showStatModal &&
                <LastFiveStatsModal termId={athlete.term_id} athlete={athlete} closeModal={closeModal} />
            )}

          </>
        )}

          {athlete.promo && (
            <>
              <button className="promo" onClick={() => handleInfoClick("promo")} title="Clover means this is a Limited time promo offer!">
                🍀
              </button>
            </>
          )}

          {athleteHard && (
            <>
              <button className="promo" onClick={() => handleInfoClick("hard")} title="Finger Cross means higher payout, tougher stat">
                🤞
              </button>
            </>
          )}

          {athleteEasy&& (
            <>
              <button className="promo" onClick={() => handleInfoClick("easy")} title="Money Mouth means it's easier to hit, with less pay">
                🤑
              </button>
            </>
          )}
        </div>
      </div>
      <img height="110" alt={athlete.name} src={athlete.image} />

      {isAdmin ? (
        <h3 className="name">
          <a target="_blank" href={`/wp-admin/term.php?taxonomy=${athlete.league}-athlete&tag_ID=${athlete.term_id}`}>
            {athlete.name} {athlete.position && (<small>- {athlete.position}</small>)}
          </a>
        </h3>
      ) : (
        <h3 className="name">{athlete.name} {athlete.position && (<small>- {athlete.position}</small>)}</h3>
      )}

      <div className="card-txt">
        {athlete.team_short} {locationTxt} {athlete.opponent_short}
      </div>

      {!countdown && <div className="card-txt start-time">{startTime}</div>}

      <div className="card-txt countdown">{countdown}</div>
      <div className={"avg-stat mt-1 mb-2" + (moreSelected || lessSelected ? " selected" : "")}>
        {Object.keys(athlete.alt_stats).length > 1 && !isH2H && (
          <span className="btn-swap mr-1" onClick={handleStatSwap} aria-label="Swap Stats">
            <i className="fas fa-sync-alt" aria-hidden="true"></i>
          </span>
        )}
        <span>{statValue}</span> <span style={{ fontSize: "12px" }}>{athlete.stat_display}</span>
      </div>
      <div className="row ml-btns">
        <div className={(moreLess ? "col-6" : "col-12") + " border-middle ml-btn" + (moreSelected ? " selected" : "")}>
          <label htmlFor={`more-button-${athlete.athlete_id}`} className="sr-only">Select More</label>
          <button id={`more-button-${athlete.athlete_id}`} onClick={onClick} value={athlete.athlete_id} data-promo={promo} data-prop="more" data-value={statValue} data-stat={athlete.stat_key} className={"athlete-btn" + (moreSelected ? " selected" : "")}>
            <i className="fa-solid fa-arrow-up"></i> MORE
          </button>
        </div>

        {moreLess && (
          <div className={"col-6 ml-btn" + (lessSelected ? " selected" : "")}>
            <label htmlFor={`less-button-${athlete.athlete_id}`} className="sr-only">Select Less</label>
            <button id={`less-button-${athlete.athlete_id}`} onClick={onClick} value={athlete.athlete_id} data-promo={promo} data-value={statValue} data-prop="less" data-stat={athlete.stat_key} className={"athlete-btn" + (lessSelected ? " selected" : "")}>
              <i className="fa-solid fa-arrow-down"></i> LESS
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AthleteCard;